import { useEffect, useState } from 'react'
import { Check, Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

type Props = { steps: string[]; finished: boolean }

const STEP_MS = 550

/**
 * The creation is one transaction on the server; the steps make it legible. The last step only
 * turns green once the server has answered.
 */
export function WinnerCreating({ steps, finished }: Props) {
  const [reached, setReached] = useState(0)

  useEffect(() => {
    if (reached >= steps.length - 1) return
    const timer = window.setTimeout(() => setReached((n) => n + 1), STEP_MS)
    return () => window.clearTimeout(timer)
  }, [reached, steps.length])

  return (
    <div className="mx-auto flex max-w-md flex-col gap-6 py-16">
      <h3 className="text-xl font-semibold tracking-tight">Création du dossier…</h3>
      <ul className="space-y-3" data-testid="winner-import-creating-steps">
        {steps.map((step, index) => {
          const done = index < reached || (finished && index === steps.length - 1) || (finished && index <= reached)
          const active = !done && index === reached
          return (
            <li key={step} className={cn('flex items-center gap-3 text-sm', !done && !active && 'text-muted-foreground')}>
              <span className={cn('flex h-5 w-5 items-center justify-center rounded-full', done && 'bg-emerald-500 text-white')}>
                {done ? <Check className="h-3 w-3" /> : active ? <Loader2 className="h-4 w-4 animate-spin" /> : <span className="h-1.5 w-1.5 rounded-full bg-slate-300" />}
              </span>
              {step}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
